export default "__VITE_ASSET__f273e5a5__"